export default __webpack_public_path__ + "static/media/interno_2.af93ef1b.jpg";